import { QueryBuilder } from "@nerdjs/nerd-network";

const queryBuilder = new QueryBuilder();

export { queryBuilder };
